import { FeatureToggleClientService } from 'feature-toggle-client';
export const ActiveMessagesPermission = 'active-messages-permission';
export const ActiveMessageSettingsValidation = 'active-message-settings-validation';
export class ActiveMessageFeatures {
    static isActiveMessagesPermissionEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(ActiveMessagesPermission, false);
    }
    static isActiveMessageSettingsValidationEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(ActiveMessageSettingsValidation, false);
    }
}
